import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import Image1 from '../assets/carousel/image-1.webp'
import Image2 from '../assets/carousel/image-2.webp'
import Image3 from '../assets/carousel/image-3.webp'
import Image4 from '../assets/carousel/image-4.webp'
import Image5 from '../assets/carousel/image-5.webp'
import Image6 from '../assets/carousel/image-6.webp'
import Image7 from '../assets/carousel/image-7.webp'
import Image8 from '../assets/carousel/image-8.webp'
import Image9 from '../assets/carousel/image-9.webp'
import Image10 from '../assets/carousel/image-10.webp'
import Image11 from '../assets/carousel/image-11.webp'

const IMAGES = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  // Image6,
  // Image7,
  // Image8,
  // Image9,
  // Image10,
  // Image11
]

const AboutUsImages = () => {
  return (
    <div className="AboutUsImages">
      <Swiper
        className='AboutUsImages__Swiper'
        modules={[ Autoplay ]}
        slidesPerView={3}
        spaceBetween={24}
        breakpoints={{
          992: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          }
        }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false
        }}
        allowTouchMove={false}
        loop
        speed={1500}
      >
        {IMAGES.map((image, index) => (
          <SwiperSlide key={`AboutUs-Image-${index}`}>
            <img
              className='AboutUsImages__Image'
              src={image}
              alt='Vida Cowork'
              title='Vida Cowork'
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default AboutUsImages